import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import GestaoUsuarios from "../Modulos/GestaoUsuarios/GestaoUsuarios";

const GestaoUsuariosRoute = () => {
    return (
        <>
            <NavBar
                title="GESTÃO DE USUÁRIOS"
                navTo="/modules"
            />
            <GenericBody>
                <GestaoUsuarios />
            </GenericBody>
        </>
    );
};

export default GestaoUsuariosRoute;
